export default () => {

  window.libInfo = (btn) => {
    const row = btn.closest('tr');
    const descRow = row && row.nextElementSibling;
    if (!descRow) return;
    btn.classList.toggle('open');
    descRow.classList.toggle('open');
  };

};